import { ShieldAlert, ShieldCheck } from "lucide-react";

const TILES = [
  { key: "pending", label: "Pending", color: "text-gray-300", sum: ["pending", "processing"] },
  { key: "needs_review", label: "Needs review", color: "text-amber-300", sum: ["needs_review"] },
  { key: "approved", label: "Approved", color: "text-emerald-300", sum: ["approved"] },
  { key: "exceptions", label: "Exceptions", color: "text-purple-300", sum: ["exception", "rejected"] },
  { key: "failed", label: "Failed", color: "text-rose-300", sum: ["failed"] },
];

export default function PortalStats({ stats, onPick }) {
  const c = stats?.counts || {};
  return (
    <div className="space-y-3" data-testid="portal-stats">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {TILES.map((t) => (
          <button
            key={t.key}
            onClick={() => onPick(t.sum.length === 1 ? t.sum[0] : t.key === "pending" ? "processing" : "rejected")}
            data-testid={`portal-stat-${t.key}`}
            className="bg-gray-950 border border-white/5 rounded-xl p-3 text-left hover:border-white/20 transition-colors duration-200"
          >
            <div className="text-[10px] font-mono uppercase tracking-wide text-gray-400">{t.label}</div>
            <div className={`font-display font-bold text-xl mt-0.5 ${t.color}`}>{t.sum.reduce((n, k) => n + (c[k] || 0), 0)}</div>
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 text-[10px] font-mono">
        <span className="px-2 py-1 rounded-lg border border-amber-500/30 text-amber-300" data-testid="portal-events-needing-review">{stats?.events_needing_review || 0} timeline events need review</span>
        <span className="px-2 py-1 rounded-lg border border-sky-500/30 text-sky-300" data-testid="portal-deadlines-unapproved">{stats?.deadlines_unapproved || 0} unapproved deadline candidates</span>
        <span className="px-2 py-1 rounded-lg border border-white/15 text-gray-300" data-testid="portal-undated-open">{stats?.undated_open || 0} undated facts</span>
        {stats?.export_blocked ? (
          <span className="px-2 py-1 rounded-lg border border-rose-500/40 text-rose-300 flex items-center gap-1" data-testid="portal-export-blocked"><ShieldAlert className="w-3 h-3" /> Exports blocked until review completes</span>
        ) : (
          <span className="px-2 py-1 rounded-lg border border-emerald-500/30 text-emerald-300 flex items-center gap-1" data-testid="portal-export-ready"><ShieldCheck className="w-3 h-3" /> Review complete — exports unlocked</span>
        )}
      </div>
    </div>
  );
}
